/**
 * Funzione Utile per selezionare correttamente gli elementi del DOM
 * in caso di errori annidati o liste ripetibili.
 */
export function normalizeFieldName(path: Array<string | number>) {
  return path
    .map(p => (isNaN(Number(p)) ? p : `[${p}]`))
    .join('.')
    .replace(/\.?\[(\d+)\]\./g, (_, num) => `[${num}].`);
}
